import styled from '@emotion/styled';
import { Flex } from '../../../Box';
import {
  stylesForDefaultState,
  stylesForFocusState,
  stylesForHoverState,
} from '../../../_internal/theme/stylesFor';

const InputThemeFlex = styled(Flex)`
  ${stylesForDefaultState('input')};

  &:hover {
    ${stylesForHoverState('input')};
  }

  &:focus {
    outline: 0;
    ${stylesForFocusState('input')};
  }
`;

export default InputThemeFlex;
